import { z } from 'zod';
import { RecipeSchema, WorkflowSchema } from './recipes.js';
import { ValidationResultSchema } from './validation.js';
/** One of ComfyUI's ready-made workflows, as its machine lists them (doc 35). */
export const WorkflowTemplateSchema = z.object({
    name: z.string(),
    title: z.string(),
    description: z.string(),
    /** "Image", "Video", "Product & Ads" … as ComfyUI groups them. */
    group: z.string(),
    mediaType: z.string(),
    tags: z.array(z.string()),
    models: z.array(z.string()),
    /** False: runs through Comfy.org's cloud nodes on the user's credits. */
    openSource: z.boolean(),
    thumbnailUrl: z.string(),
});
export const WorkflowTemplatesResponseSchema = z.object({ templates: z.array(WorkflowTemplateSchema) });
export const MAX_IMPORT_BYTES = 4 * 1024 * 1024;
/** A template by name, or a workflow file — the editor's format or the API format. */
export const ImportWorkflowRequestSchema = z.object({
    machineId: z.string().min(1).max(64),
    template: z.string().trim().min(1).max(200).regex(/^[\w.-]+$/, 'A template name from the machine\'s list').optional(),
    workflow: z.record(z.string(), z.unknown()).optional(),
    title: z.string().trim().min(1).max(120).optional(),
    /** False only checks it: nothing is saved. */
    save: z.boolean().default(true),
}).refine((r) => (r.template === undefined) !== (r.workflow === undefined), 'Send either a template or a workflow');
/** A model file the workflow names, and where the template says to get it. */
export const WorkflowModelSchema = z.object({
    name: z.string(),
    directory: z.string().nullable(),
    url: z.string().nullable(),
    installed: z.boolean(),
});
export const ImportReportSchema = z.object({
    /** Node types this machine does not have — custom node packs to install (doc 34). */
    missingNodes: z.array(z.string()),
    models: z.array(WorkflowModelSchema),
    warnings: z.array(z.string()),
    validation: ValidationResultSchema,
});
export const ImportWorkflowResponseSchema = z.object({
    recipe: RecipeSchema.nullable(),
    workflow: WorkflowSchema.nullable(),
    report: ImportReportSchema,
});
//# sourceMappingURL=templates.js.map